/** Provider callbacks visit Identity once so its host-only locale choice survives.
 * The onboarding loader verifies the signed intent before granting event routing.
 */
export function meetupProviderReturnUrl(search: URLSearchParams, identityUrl: string): string {
  const destination = search.get('redirectUrl') || '/';
  const intent = search.get('meetupIntent');
  if (!intent) return destination;
  const callback = new URL('/onboarding', identityUrl);
  callback.searchParams.set('redirectUrl', destination);
  callback.searchParams.set('meetupIntent', intent);
  return callback.toString();
}
